'use client';

import React from 'react';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/src/components/ui/carousel';
import { IResolvedNote } from '@/src/utils/collections/review.mapper';
import { ReviewNoteCell } from '@/src/components/review/ReviewDetailed/ReviewNote/ReviewNoteCell';
import { ReviewButtons } from '@/src/components/review/ReviewDetailed/ReviewButtons';

type IReviewNoteListProps = {
  notes: IResolvedNote[];
};

export const ReviewNoteList = ({ notes }: IReviewNoteListProps) => {
  return (
    <Carousel
      opts={{
        align: 'start',
      }}
      className="w-full lg:max-w-2xl"
    >
      <CarouselContent className={'ml-4'} gradientOverflow={true}>
        {notes.map((note, index) => (
          <CarouselItem
            key={note.date + '_' + index}
            className={'basis-1/1 first:pl-0'}
          >
            <ReviewNoteCell data={note} />
          </CarouselItem>
        ))}
      </CarouselContent>
      <ReviewButtons />
    </Carousel>
  );
};
